import React from "react";
import styled from "@emotion/styled";
import { Eye } from "../../icons/Eye";
import { easelColors } from "../../helpers/constants";
import { mq } from "../../helpers/mediaQueries";
import { EaselButton } from "../global/EaselButton";

export interface PreviewLinkProps {
  href: string;
  target?: string;
}
export const PreviewButton: React.FC<PreviewLinkProps> = ({
  target = "_blank",
  href,
}: PreviewLinkProps) => {
  return (
    <EaselButton data-test-id="preview" size="xs" variant="secondary">
      <PreviewLink href={href} target={target}>
        <Eye fill={easelColors.white} />
        <span>View as Student</span>
      </PreviewLink>
    </EaselButton>
  );
};

const PreviewLink = styled.a(
  mq({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.875rem",
    textDecoration: "none",
    color: easelColors.white,
    fontWeight: 500,
    span: {
      display: ["none", "initial", null],
    },
    svg: {
      marginRight: ["0", "0.5rem", null],
    },

    "&:hover": {
      textDecoration: "none",
      color: easelColors.white,
    },
  })
);
